<template>
    <section class="farmerContainer">
        <div class="container-fluid farms">
            <div class="row margin_top_lg">
                <div class="col-lg-3 offset-lg-1">
                    <side-bar />
                </div>
                <div class="col-lg-7">
                    <div class="form-container">
                        <div class="container form_body">
                            <div class="section_header font-md">
                                <h2 class=" color__black font-bold">Edit Profile</h2>
                            </div>
                            <div class="content_inner">
                                <form action="#" @submit.prevent="submitForm">
                                    <div class="user_profile_details">
                                        <div class="user_info_avi avi_lg">
                                            <img :src="img" alt="" style="width: 100%; height: 100%;">
                                            <span class="default_avi">{{user.fullName | initials}}</span>
                                        </div>
                                        <div class="user_details_wrapper">
                                            <div class="user_info">
                                                <h5 class="title font-bold">Change image</h5>
                                                <span class="font-sm color__grey_dark">Accepts .png, .jpg or .jpeg</span>
                                            </div>
                                            <div class="profile_action_btn">
                                                <label for="upload_imgs" class="btn btn-default-outline btn-sm box_curved loading">
                                                    <input type="file" accept=".png, .jpg, .jpeg" name="file" id="upload_imgs" hidden="" :disabled="uploading"
                                                    @change="onPhotoChange" class="inputfile">
                                                    <span>Change Photo</span>
                                                    <span><Loading :smallSpinner="true" v-if="uploading" /></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
            
                                    <div class="base_divider"></div>
            
                                    <div class="row form_row_group">
                                        <div class="form_group_item col-md-4">
                                            <h4 class="form_row_title font-bold caps_upper requiredField">Gender</h4>
                                        </div>
                                        <div class="form_group_item col-md-8">
                                            <label for="genderMale" class="radio-inline">
                                                <input type="radio" id="genderMale" checked name="userGender" value="male" v-model="formData.gender">
                                                <span class="label_title caps_upper">Male</span>
                                            </label>
                                            <label for="genderFemale" class="radio-inline">
                                                <input type="radio" id="genderFemale" name="userGender" value="female" v-model="formData.gender">
                                                <span class="label_title caps_upper">Female</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row form_row_group">
                                        <div class="form_group_item col-md-4">
                                            <h4 class="form_row_title font-bold requiredField caps_upper">Your Name</h4>
                                            <p class="font-sm color__grey_dark">First name and last name</p>
                                        </div>
                                        <div class="form_group_item col-md-8">
                                            <div class="form-row">
                                                <div class="col-sm-6">
                                                    <label for="" class="control-label sr-only requiredField">First Name</label>
                                                    <input type="text" class="form-control" v-model="formData.firstName" placeholder="Rubius">
                                                </div>
                                                <div class="col-sm-6">
                                                    <label for="" class="control-label sr-only">Last Name</label>
                                                    <input type="text" v-model="formData.lastName" class="form-control" placeholder="Hagrid">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
            
                                    <div class="row form_row_group">
                                        <div class="form_group_item col-md-4">
                                            <h4 class="form_row_title font-bold caps_upper">Email Address</h4>
                                        </div>
                                        <div class="form_group_item col-md-8">
                                            <label for="" class="control-label sr-only caps_upper">Email Address</label>
                                            <input type="email" class="form-control" disabled :value="user.email">
                                        </div>
                                    </div>
            
                                    <div class="row form_row_group">
                                        <div class="form_group_item col-md-4">
                                            <h4 class="form_row_title font-bold caps_upper requiredField">Phone Number</h4>
                                        </div>
                                        <div class="form_group_item col-md-8">
                                            <label for="" class="control-label sr-only caps_upper requiredField">Phone Number</label>
                                            <div class="inputaffixed inputPrefixed">
                                                <div class="inputfixture">
                                                    <span>+234</span>
                                                </div>
                                                <input type="tel" id="us_phone" maxlength="11" class="inputControl form-control"
                                                    placeholder="Enter Phone number" v-model="formData.phoneNo" >
                                            </div>
                                        </div>
                                    </div>
            
                                    <div class="row form_row_group">
                                        <div class="form_group_item col-md-4">
                                            <h4 class="form_row_title font-bold caps_upper requiredField">Address</h4>
                                        </div>
                                        <div class="form_group_item col-md-8">
                                            <div class="form-group">
                                                <div class="form-group">
                                                    <input type="text" v-model="formData.address" class="form-control" placeholder="Street Address">
                                                </div>
                                                <div class="form-row">
                                                    <div class="col-6 required">
                                                        <select class="form-control" :disabled="loadingStates" v-model="formData.state_id">
                                                            <option v-if="loadingStates" value="">
                                                                loading ...
                                                            </option>
                                                            <option v-else-if="states.length !== 0" value="">Select State</option>
                                                            <option v-for="(st, index) in states" :key="index" :value="st.id">
                                                                {{st.name}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="col-6 required">
                                                        <input type="text" v-model="formData.city" class="form-control" placeholder="City / Town">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end">
                                        <submit-button class="btn btn-primary" :loading="submitting" :disabled="checkFields">Save changes</submit-button>
                                    </div>
            
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="d-flex justify-content-end margin_top_lg">
                <button class="btn btn-support btn-sm py-2 font-sm">
                    <svg width="24" height="24" viewBox="0 0 24 24" class="mr-2" style="height: 16px; margin-bottom: -2px;"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M11 5C8.23858 5 6 7.23858 6 10V11V18H3C1.89543 18 1 17.1046 1 16V12C1 10.8954 1.89543 10 3 10L4 10C4 6.13401 7.13401 3 11 3H13C16.866 3 20 6.13401 20 10H21C22.1046 10 23 10.8954 23 12V16C23 17.1046 22.1046 18 21 18H19.874C19.4299 19.7252 17.8638 21 16 21H14.7324C14.3866 21.5978 13.7403 22 13 22C11.8954 22 11 21.1046 11 20C11 18.8954 11.8954 18 13 18C13.7403 18 14.3866 18.4022 14.7324 19H16C17.1046 19 18 18.1046 18 17V11V10C18 7.23858 15.7614 5 13 5H11ZM4 12H3L3 16H4V12ZM11 12.25C11 12.9404 10.4404 13.5 9.75 13.5C9.05964 13.5 8.5 12.9404 8.5 12.25C8.5 11.5596 9.05964 11 9.75 11C10.4404 11 11 11.5596 11 12.25ZM14.25 13.5C14.9404 13.5 15.5 12.9404 15.5 12.25C15.5 11.5596 14.9404 11 14.25 11C13.5596 11 13 11.5596 13 12.25C13 12.9404 13.5596 13.5 14.25 13.5ZM20 12H21V16H20V12Z"
                            fill="#F2950A" />
                    </svg>
            
                    Support</button>
            </div>
        </div>
        
    </section>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import SideBar from '@/components/off-taker/SideBar'
export default {
    data() {
        return {
            uploading: false,
            submitting: false,
            formData: {
                city: '',
                phoneNo: '',
                firstName: '',
                lastName: '',
                gender: '',
                address: '',
                state_id: '',
                avatar: ''
            },
            img: '',
            file: '',
            disabledField: false
        }
    },
    computed: {
        ...mapState(['user','states','expires','token','loadingStates','farms','loadingFarms']),
        checkFields() {
            if (this.formData.phoneNo === '' || this.formData.city === '' || this.formData.firstName === '' || this.formData.lastName === '') {
                return true;
            }
            if (this.formData.state_id === '' || this.formData.address === '' || this.formData.gender === '') {
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapActions(['getStates', 'getFarms']),
        ...mapMutations(['login_user']),
        checkStates() {
            if (this.states.length === 0) {
                this.getStates();
            }
        },
        onPhotoChange(e) {
            this.file = event.target.files[0];
            this.img = window.URL.createObjectURL(this.file);
        },
        submitForm() {
            this.submitting = true;
            if(this.file) {
                this.uploadAvatar();
            } else {
                if(this.user.avatar) {
                    this.formData.avatar = this.user.avatar
                }
                this.updateProfile();
            }
            
        },
        uploadAvatar() {
            this.uploading = true;
            this.$http.uploadFile(this.file)
            .then((response) => {
                console.log('response from upload ', response)
                this.formData.avatar = response.data.url;
                this.updateProfile();
            })
            .catch((error) => {
                this.$toastr.error(error);
            })
            .finally(() => {
                this.uploading = false;
            })
        },
        
        updateProfile() {
            this.$http.put('users/profile', this.formData)
            .then((response) => {
                const obj = { 
                    token: this.token,
                    user: response.data,
                    expires_at: this.expires_at 
                 };
                this.login_user(obj);
                console.log('Response from profile update ',response);
                this.$toastr.success('Profile updated successfully!!')
            })
            .catch((error) => {
                this.$toastr.error(error);
            })
            .finally(() => {
                this.submitting = false;
            })
        },
        assign() {
            this.formData.firstName = this.user.firstName;
            this.formData.lastName = this.user.lastName;
            this.formData.phoneNo = this.user.phoneNo;
            this.formData.address = this.user.address;
            this.formData.state_id = this.user.state_id;
            this.formData.city = this.user.city
            this.formData.gender = this.user.gender
            if(this.user.avatar) {
                this.img = this.user.avatar;
            }
        }
    },
    created() {
        this.checkStates()
        this.assign()
    },
    components: {
        SideBar
    }
}
</script>

<style>

</style>